module.exports = __webpack_public_path__ + "static/media/home.dfc964bb.svg";